import { axios } from './axios';

export const getDiscountByCode = async (code: string) => {
  return axios.get(`/discount/?avoid_validation=true&discount_code=${code}`);
};
